<template>
    <vs-dialog width="550px" not-center v-model="active">
        <template #header>
            <h4 class="not-margin">
                Borrar sesiones
            </h4>
        </template>


        <div>
            <p>
                <strong>¿Esta seguro de borrar la sesión?</strong>
            </p>
            <p>Esta será eliminada permanentemente</p>
        </div>
        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false">
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="deleteRow()">
                        Enviar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
    </vs-dialog>
</template>
<script>
import sesiones from '../../../../../api/requests/sesiones.js'
export default {
    props:[
        'value',
        'rowData'
    ],
    data () {
        return {
            active: false
        }
    },
    methods: {
        async deleteRow () {
            try {
                const payload = {
                    ids: this.checkByType ('string', this.rowData.ids) 
                        ? this.rowData.ids.split(',') : null
                }
                const response = await sesiones.deleteSesion(payload)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Exito',
                    text: `Sesión eliminado`
                })
                this.$emit('refreshTable',true)
                this.active = false
            } catch (error) {
                this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error',
                        text: `Algo salió mal`
                })
            }
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>
<style scoped>
    .con-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .con-footer .vs-button .vs-button__content {
        padding: 10px 30px;
    }
    .con-footer .vs-button {
        margin: 0;
    }
    .not-margin {
        margin: 0;
        font-weight: 400;
        padding: 10px 10px 0;
    }
    .con-content {
        justify-content: space-between;
        width: 100%;
    }
    .con-content p {
        font-size: .8rem;
        padding: 0 10px;
    }
    .con-content, .con-content>div {
        display: flex;
        align-items: center;
    }
</style>